import { getCurrentRankConfig, parseRankStringToLevelSublevel } from './rank-helpers';
import { cfgToThemeCdnPath } from '@infinitro/config';
/**
 * Build badge image path from level 1–11 and sublevel 0–5.
 * When sublevelImages is true: /badges/{levelNum}.{sublevel}.png for sublevel > 0, else /badges/{levelNum}.png.
 * When false or undefined: always /badges/{levelNum}.png (one image per level).
 */
export const getBadgeImagePath = (levelNum, sublevel, sublevelImages) => {
    const useSublevel = sublevelImages === true && sublevel > 0;
    const file = useSublevel ? `${levelNum}.${sublevel}.png` : `${levelNum}.png`;
    return cfgToThemeCdnPath(`/badges/${file}`);
};
/** Resolve rank (number = level index, string = rank name or "level.sub") to level index 1–11. */
function levelNumFromRank(rank) {
    if (rank == null)
        return undefined;
    if (typeof rank === 'string' && rank.trim() === '')
        return undefined;
    if (typeof rank === 'number') {
        const n = Math.round(rank);
        return n >= 1 && n <= 11 ? n : undefined;
    }
    const { levelIndex } = parseRankStringToLevelSublevel(rank);
    return levelIndex >= 1 && levelIndex <= 11 ? levelIndex : undefined;
}
export const getRankIconInfo = (rank, level) => {
    const levelNum = levelNumFromRank(rank);
    const sublevel = level != null ? Math.min(5, Math.max(0, Math.round(level))) : 0;
    const rankName = levelNum != null
        ? `Rank ${levelNum}`
        : `Rank ${parseRankStringToLevelSublevel(rank).levelIndex}`;
    const config = getCurrentRankConfig();
    const imageSrc = levelNum != null ? getBadgeImagePath(levelNum, sublevel, config.sublevelImages) : undefined;
    return {
        rankName,
        imageSrc
    };
};
